import { useContext, useEffect, useRef, useState } from "react";
import { Box, alpha, useTheme, lighten, darken, Drawer, SxProps } from "@mui/material";
import Scrollbar from "@components/ScrollBar";
import { SidebarContext } from "@utilities/contexts/SideBarContext";
import SidebarMenu from "@layouts/SideBarMenu";

const SidebarContent = ({ sx }: { sx: SxProps }) => {
    const theme = useTheme();
    const ref = useRef<HTMLElement>(null);
    const [bottomPadding, setBottomPadding] = useState<number>(0);

    useEffect(() => {
        setBottomPadding(ref.current?.getBoundingClientRect().height ?? 0);
        // eslint-disable-next-line
    }, [ref.current]);

    return (
        <Box
            sx={{
                width: `${theme.sidebar.width}`,
                minWidth: `${theme.sidebar.width}`,
                color: `${theme.colors.alpha.trueWhite[70]}`,
                zIndex: 7,
                height: "100%",
                paddingBottom: bottomPadding + 16 + "px",
                background:
                    theme.palette.mode === "dark"
                        ? alpha(lighten(theme.header.background ? theme.header.background.toString() : "", 0.1), 0.5)
                        : darken(theme.colors.alpha.black[100], 0.2),
                boxShadow: theme.palette.mode === "dark" ? theme.sidebar.boxShadow : "none",
                ...sx,
            }}
        >
            <Scrollbar>
                <Box mt={3} mb={5} mx={2} display={"flex"} justifyContent={"center"}>
                    <img src={`${process.env.PUBLIC_URL}/static/images/logo/thals-logo.png`} alt="Thals-logo" />
                </Box>
                <SidebarMenu />
            </Scrollbar>
        </Box>
    );
};

function Sidebar() {
    const { sidebarToggle, closeSidebar } = useContext(SidebarContext);

    return (
        <Box>
            <SidebarContent
                sx={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    display: {
                        xs: "none",
                        lg: "inline-block",
                    },
                }}
            />
            <Drawer anchor="left" open={sidebarToggle} onClose={closeSidebar}>
                <SidebarContent sx={{ position: "relative" }} />
            </Drawer>
        </Box>
    );
}

export default Sidebar;
